import React from 'react';

const OfferCard = ({ imageSrc, backgroundColorClass }) => {

  const contentClasses = `home-offer-card-content ${backgroundColorClass}`;

  return (
    <div className="home-offer-card-slide-item"> 
      <div className={contentClasses}>
        {imageSrc && (
            <img 
                src={imageSrc} 
                alt="Offer" 
                className="home-offer-card-full-image"
            />
        )}
      </div>
    </div>
  );
};

export default OfferCard;